import React from "react";
import { Link } from "react-router-dom";
import bannerImg from "../../assets/home/radiomonitor-site.jpg";
import { authFetch } from "../../authFetch";

const PUB = process.env.PUBLIC_URL + "/assets/home";
const roleOwner = `${PUB}/role-owner.svg`;
const roleProgram = `${PUB}/role-program.svg`;
const roleTech = `${PUB}/role-tech.svg`;
const rolePromo = `${PUB}/role-promo.svg`;
const roleSales = `${PUB}/role-sales.svg`;
const markGreen = `${PUB}/mark-green.svg`;
const presentationIcon = `${PUB}/icon_doc.svg`;
const arrowIcon = `${PUB}/arrow.svg`;
const moreLinkLayout = {
  stats: { marginTop: 32, display: "flex", justifyContent: "flex-end" },
  silence: { marginTop: 32, display: "flex", justifyContent: "flex-end" },
  link: {
    display: "inline-flex",
    alignItems: "center",
    gap: 8,
    color: "#006b44",
    fontSize: 16,
    fontWeight: 400,
    textDecoration: "none"
  },
  icon: { width: 19, height: 19, display: "block" }
};
const pricingStats = `${PUB}/pricing-stats.svg`;
const pricingMonitor = `${PUB}/pricing-monitor.svg`;
const presentationUaLink = 'https://docs.google.com/presentation/d/1klEjqc-XznF_S_W_qXHqp9MTijPwEgRwxdOim34cSsc/edit?usp=sharing';

const HERO_ROLES = [
  "Propriétaires de radios",
  "Directeurs de la programmation",
  "Directeurs techniques",
  "Service promo de la station",
  "Équipe commerciale",
];

const CLIENT_LOGOS = [
  process.env.PUBLIC_URL + "/assets/home/001_Logo_Rodynne.svg",
  process.env.PUBLIC_URL + "/assets/home/004_Logo_Prishepkin.svg",
  process.env.PUBLIC_URL + "/assets/home/003_Logo_Karamelka.svg",
  process.env.PUBLIC_URL + "/assets/home/004_Logo_Baba.svg",
];
const SUCCESS_FEATURES = [
  "Planification efficace de l'antenne et des blocs publicitaires",
  "Données transparentes pour les annonceurs",
  "Vision claire de la croissance et de la fidélité de l'audience",
  "Garantie que l'antenne ne s'arrêtera pas sans que vous le sachiez",
];
const FEATURE_DOT_SIZE = 20;
const FEATURE_DOT_COLOR = "#006b44";
const featureDotStyle = (size = FEATURE_DOT_SIZE) => ({
  width: size,
  height: size,
  borderRadius: 999,
  background: FEATURE_DOT_COLOR,
  display: "inline-block",
});

function ClientsCarousel() {
  const logos = CLIENT_LOGOS;
  const vis = 4;
  const step = 100 / vis;
  const [idx, setIdx] = React.useState(0);
  const [anim, setAnim] = React.useState(true);

  const track = React.useMemo(() => [...logos, ...logos.slice(0, vis)], [logos, vis]);

  React.useEffect(() => {
    const t = setInterval(() => setIdx((i) => i + 1), 3500);
    return () => clearInterval(t);
  }, [logos.length]);

  const onTransitionEnd = () => {
    if (idx >= logos.length) {
      setAnim(false);
      setIdx(0);
      setTimeout(() => setAnim(true), 20);
    }
  };

  const prev = () => {
    if (idx === 0) {
      setAnim(false);
      setIdx(logos.length);
      setTimeout(() => {
        setAnim(true);
        setIdx(Math.max(logos.length - 1, 0));
      }, 20);
    } else {
      setIdx((i) => i - 1);
    }
  };

  const next = () => setIdx((i) => i + 1);

  if (!logos.length) return null;

  return (
    <div style={{ display: "flex", alignItems: "center", gap: 16, margin: "8px 0 14px" }}>
      <button
        type="button"
        onClick={prev}
        aria-label="Précédent"
        style={{
          width: 36,
          height: 36,
          borderRadius: 999,
          border: "1px solid #cfd5d1",
          background: "#fff",
          cursor: "pointer",
          fontSize: 20,
          lineHeight: "34px",
        }}
      >
        ‹
      </button>

      <div style={{ overflow: "hidden", flex: "1 1 auto" }}>
        <div
          onTransitionEnd={onTransitionEnd}
          style={{
            display: "flex",
            transform: `translateX(-${idx * step}%)`,
            transition: anim ? "transform 900ms ease" : "none",
            willChange: "transform",
          }}
        >
          {track.map((src, i) => {
            const isPrishepkin = src.includes("004_Logo_Prishepkin.svg");
            return (
              <div
                key={src + i}
                style={{
                  flex: `0 0 ${step}%`,
                  padding: "0 26px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  boxSizing: "border-box",
                }}
              >
                <img
                  src={src}
                  alt=""
                  style={{
                    maxWidth: isPrishepkin ? 195 : 130,
                    width: "100%",
                    height: "auto",
                    display: "block",
                  }}
                />
              </div>
            );
          })}
        </div>
      </div>

      <button
        type="button"
        onClick={next}
        aria-label="Suivant"
        style={{
          width: 36,
          height: 36,
          borderRadius: 999,
          border: "1px solid #cfd5d1",
          background: "#fff",
          cursor: "pointer",
          fontSize: 20,
          lineHeight: "34px",
        }}
      >
        ›
      </button>
    </div>
  );
}

export default function HomeFr({ isAuth }) {
  const [statsPriceEUR, setStatsPriceEUR] = React.useState(null);
  const [monitorPriceEUR, setMonitorPriceEUR] = React.useState(null);

  React.useEffect(() => {
    let cancelled = false;
    Promise.all([
      authFetch("/products/STATS/price-uah").then((r) => (r.ok ? r.json() : Promise.reject(r.status))),
      authFetch("/products/MONITORING/price-uah").then((r) => (r.ok ? r.json() : Promise.reject(r.status))),
    ])
      .then(([stats, monitoring]) => {
        if (cancelled) return;
        setStatsPriceEUR(typeof stats?.price_eur === "number" ? stats.price_eur : null);
        setMonitorPriceEUR(typeof monitoring?.price_eur === "number" ? monitoring.price_eur : null);
      })
      .catch(() => {
        if (cancelled) return;
        setStatsPriceEUR(null);
        setMonitorPriceEUR(null);
      });
    return () => {
      cancelled = true;
    };
  }, []);
  const statsPriceText =
    statsPriceEUR !== null ? `${Math.ceil(statsPriceEUR).toLocaleString("fr-FR")} €/mois` : "— €/mois*";
  const monitorPriceText =
    monitorPriceEUR !== null ? `${Math.ceil(monitorPriceEUR).toLocaleString("fr-FR")} €/mois` : "— €/mois";

  return (
    <div
      style={{
        width: "100%",
        minHeight: 0,
        display: "flex",
        justifyContent: "center",
        paddingTop: 0,
        paddingBottom: "clamp(16px, 4vw, 32px)",
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: 1100,
          paddingTop: 0,
          paddingRight: "clamp(16px, 5vw, 48px)",
          paddingBottom: "clamp(16px, 5vw, 48px)",
          paddingLeft: "clamp(16px, 5vw, 48px)",
          boxSizing: "border-box",
          color: "#2e2e2e",
          lineHeight: 1.6,
          fontSize: 16,
          wordBreak: "break-word",
          overflowWrap: "anywhere",
        }}
      >
        <img
          src={bannerImg}
          alt=""
          style={{ width: "100%", height: "auto", display: "block", marginBottom: 24 }}
        />
        {/* === Bloc 1 : Analytics + monitoring === */}
        <section style={{ margin: "0 0 28px" }}>
          <h2 style={{ fontSize: 42, fontWeight: 900, color: "#006b44", margin: 0 }}>
            Analytique et monitoring pour la radio en ligne
          </h2>

          <p style={{ margin: "16px 0 10px", fontSize: 18 }}>
            <strong>Radiomonitor.net</strong> est un service moderne pour les radios en ligne qui réunit une statistique détaillée des auditeurs et un contrôle technique 24/7 de l'antenne
          </p>
          <p style={{ margin: "0 0 24px", fontSize: 18 }}>
            Obtenez des données transparentes sur votre audience, prouvez la portée réelle aux annonceurs et démontrez l'efficacité des blocs publicitaires
          </p>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(5, 1fr)",
              gap: 0,
              alignItems: "start",
              paddingTop: 8,
            }}
          >
            {HERO_ROLES.map((label, index) => (
              <div
                key={label}
                style={{
                  textAlign: "center",
                  padding: "0 24px",
                }}
              >
                <img
                  src={[roleOwner, roleProgram, roleTech, rolePromo, roleSales][index]}
                  alt={label}
                  style={{
                    width: 120,
                    height: 120,
                    display: "block",
                    margin: "0 auto 10px",
                    objectFit: "contain",
                  }}
                />
                <div style={{ color: "#006b44", fontWeight: 400 }}>{label}</div>
              </div>
            ))}
          </div>

          <p style={{ margin: "24px 0 0", fontSize: 18 }}>
            <strong>Radiomonitor.net</strong> est la solution pour celles et ceux qui veulent tout savoir sur leurs auditeurs et rester certains de la stabilité de l'antenne
          </p>
          <div
            style={{
              marginTop: 18,
              display: "inline-flex",
              alignItems: "center",
              gap: 10,
            }}
          >
            <img
              src={presentationIcon}
              alt=""
              style={{ width: 22, height: 22 }}
              aria-hidden="true"
            />
            <a
              href={presentationUaLink}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                color: "#006b44",
                textDecoration: "none",
                fontSize: 18,
                fontWeight: 700,
              }}
            >
              Ouvrir la présentation <span style={{ fontWeight: 800 }}>Radiomonitor.net</span>
            </a>
          </div>
        </section>
        <div style={{ height: 1, background: "#006b44", opacity: 0.35, margin: "24px 0" }} />

        {/* === Bloc 2 : Statistiques === */}
        <section style={{ margin: "36px 0 16px" }}>
          <h2 style={{ fontSize: 40, fontWeight: 900, color: "#006b44", margin: "0 0 8px" }}>
            <Link to="service/stats#stats-hero" style={{ color: "inherit", textDecoration: "none", display: "inline-block" }}>
              Statistiques des auditeurs radio en ligne
            </Link>
          </h2>
          <p style={{ margin: "0 0 16px", fontSize: 18 }}>
            Collectez des données utiles pour votre business. Avec <strong>Radiomonitor.net</strong> vous savez toujours qui vous écoute et à quel moment
          </p>
          <ul style={{ margin: 0, paddingLeft: 24, fontSize: 18 }}>
            <li>Nombre d'auditeurs uniques et de connexions</li>
            <li>Géographie et appareils</li>
            <li>Heures de pointe et prime time</li>
            <li>TSL (temps d'écoute moyen)</li>
            <li>Nouveaux auditeurs, rétention et loyauté</li>
            <li>Top-40 et statistiques publicitaires</li>
          </ul>
          <div style={{ display: "flex", gap: 16, alignItems: "flex-start", marginTop: 28 }}>
            <img
              src={markGreen}
              alt=""
              style={{
                width: 72,
                height: 72,
                borderRadius: 8,
                flex: "0 0 auto",
                transform: "translateY(10px)",
              }}
            />
            <div style={{ fontSize: 18 }}>
              <div style={{ fontWeight: 800, marginBottom: 6 }}>Options supplémentaires :</div>
              <div>- Suivi du nombre d'auditeurs d'un spot publicitaire précis</div>
              <div>- Génération automatique du Top-40 des titres en rotation</div>
            </div>
          </div>
          <div style={moreLinkLayout.stats}>
            <Link to="service/stats#stats-hero" style={moreLinkLayout.link}>
              plus
              <img src={arrowIcon} alt="" style={moreLinkLayout.icon} />
            </Link>
          </div>
        </section>
        <div style={{ height: 1, background: "#006b44", opacity: 0.35, margin: "24px 0" }} />

        {/* === Bloc 3 : Monitoring silence === */}
        <section style={{ margin: "36px 0 16px" }}>
          <h2 style={{ fontSize: 40, fontWeight: 900, color: "#006b44", margin: "0 0 8px" }}>
            <Link to="service/silence" style={{ color: "inherit", textDecoration: "none", display: "inline-block" }}>
              Contrôle continu de l'antenne
            </Link>
          </h2>
          <p style={{ margin: "0 0 16px", fontSize: 18 }}>
            Votre flux reste sous surveillance. <strong>Radiomonitor.net</strong> détecte le silence et vous alerte instantanément en cas d'incident
          </p>
          <ul style={{ margin: 0, paddingLeft: 24, fontSize: 18 }}>
            <li>Surveillance des flux (MP3 et AAC+) 24/7</li>
            <li>Notifications instantanées dans Telegram</li>
            <li>Historique des niveaux sonores sur 7 jours</li>
          </ul>
          <div style={{ display: "flex", gap: 16, alignItems: "flex-start", marginTop: 28 }}>
            <img
              src={markGreen}
              alt=""
              style={{
                width: 72,
                height: 72,
                borderRadius: 8,
                flex: "0 0 auto",
                transform: "translateY(13px)",
              }}
            />
            <div style={{ fontSize: 18 }}>
              <div style={{ fontWeight: 800, marginBottom: 6 }}>Avantages :</div>
              <div>- Connexion simple sans matériel supplémentaire</div>
              <div>- Jusqu'à 3 contacts pour recevoir les alertes</div>
            </div>
          </div>
          <div style={moreLinkLayout.silence}>
            <Link to="service/silence" style={moreLinkLayout.link}>
              plus
              <img src={arrowIcon} alt="" style={moreLinkLayout.icon} />
            </Link>
          </div>
        </section>
        <div style={{ height: 1, background: "#006b44", opacity: 0.35, margin: "24px 0" }} />

        {/* === Bloc 4 : slogan + avantages === */}
        <section style={{ margin: "40px 0 8px" }}>
          <h2
            style={{
              fontSize: 40,
              fontWeight: 900,
              color: "#006b44",
              margin: "0 0 27px",
              lineHeight: 1.2,
            }}
          >
            Radiomonitor.net -
            <br />
            tout pour la réussite de votre radio en ligne
          </h2>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(4, 1fr)",
              gap: 24,
              alignItems: "start",
              marginBottom: 12,
              textAlign: "center",
              fontWeight: 700,
              fontSize: 18,
            }}
          >
            {SUCCESS_FEATURES.map((text) => (
              <div
                key={text}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: 10,
                }}
              >
                <span style={featureDotStyle()} />
                <span>{text}</span>
              </div>
            ))}
          </div>
          <p style={{ margin: 0, fontSize: 18 }}>Prenez une longueur d'avance sur vos concurrents dès aujourd'hui !</p>
        </section>
        <div style={{ height: 1, background: "#006b44", opacity: 0.35, margin: "24px 0" }} />

        {/* === Bloc 4.1 : logos === */}
        <section style={{ margin: "32px 0 0" }}>
          <h2 style={{ fontSize: 40, fontWeight: 900, color: "#006b44", margin: "0 0 3px" }}>
            Radiomonitor.net
          </h2>
          <h3
            style={{
              fontSize: 40,
              fontWeight: 900,
              color: "#006b44",
              margin: "0 0 12px",
              lineHeight: 0.8,
            }}
          >
            est choisi par les radios en ligne de référence
          </h3>

          <p style={{ margin: "0 0 18px", fontSize: 18 }}>
            <strong>Radiomonitor.net</strong> est un service international d'analytique et de monitoring déjà adopté par les principales radios en ligne. Nous aidons les stations du monde entier à obtenir des statistiques de précision, des données transparentes pour les annonceurs et la garantie d'une diffusion stable
          </p>

          <ClientsCarousel />

          <p style={{ margin: 0, fontSize: 18 }}>
            Nous serions heureux de voir votre station parmi ces logos ! Rejoignez Radiomonitor.net où que vous soyez
          </p>
        </section>
        <div style={{ height: 1, background: "#006b44", opacity: 0.35, margin: "24px 0" }} />

        {/* === Bloc 5 : tarifs === */}
        <section style={{ margin: "40px 0 0" }}>
          <h2 style={{ fontSize: 40, fontWeight: 900, color: "#006b44", margin: "0 0 24px" }}>
            Formules Radiomonitor.net
          </h2>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: 40,
              alignItems: "start",
              marginBottom: 24,
            }}
          >
            <div style={{ textAlign: "center" }}>
              <img
                src={pricingStats}
                alt=""
                style={{ width: 160, height: 160, borderRadius: 12, marginBottom: 12 }}
              />
              <div style={{ fontWeight: 800, fontSize: 22, marginBottom: 8 }}>Abonnement statistiques*</div>
              <div style={{ fontWeight: 800, fontSize: 32, color: "#006b44" }}>
                {statsPriceText}
              </div>
            </div>
            <div style={{ textAlign: "center" }}>
              <img
                src={pricingMonitor}
                alt=""
                style={{ width: 160, height: 160, borderRadius: 12, marginBottom: 12 }}
              />
              <div style={{ fontWeight: 800, fontSize: 22, marginBottom: 8 }}>Abonnement monitoring du silence**</div>
              <div style={{ fontWeight: 800, fontSize: 32, color: "#006b44" }}>
                {monitorPriceText}
              </div>
            </div>
          </div>
          <p style={{ margin: '12px 0 12px', fontSize: 14 }}>
            *Collecte, stockage et traitement des données d'un flux, 24/7, accès pour 1 personne
            <br />
            **Surveillance d'un flux, 24/7, chatbot disponible pour 1+2 personnes
          </p>
          <p style={{ margin: '12px 0 0', fontSize: 18 }}>
            Envie d'essayer ? Laissez une demande ou inscrivez votre station dès maintenant !
          </p>
        </section>
      </div>
    </div>
  );
}
